import React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { blue, salmon, gray } from '../../theme';

const AssignmentCard = (props) => {
  const styles = StyleSheet.create({
    assignmentCard: {
      height: '52px',
      background: blue[700],
      borderRadius: '4px',
      padding: '8px'
    },
    assignmentCardIcon: {
      fontSize: '20px',
      ':hover': {
        color: salmon[500]
      }
    }
  });

  const { assignment } = props;

  return (
    <div className={`mt-2 ${css(styles.assignmentCard)}`}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        {assignment.title}
        <i
          className={`fa fa-trash ${css(styles.assignmentCardIcon)}`}
          onClick={() => props.onDelete(assignment)}
        />
      </div>
      <div style={{ fontSize: '12px', fontWeight: '700', color: blue[400] }}>
        {`@ ${assignment.facilityUsername}`}
      </div>
    </div>
  );
};

export default AssignmentCard;
